import axios from 'axios';
import { apiError, logoutUserSuccess } from '../store/auth/login/actions';

// Create Axios instance
const api = axios.create({
    baseURL: 'https://api.confidoo.com.tn/',
    withCredentials: true,
});

export const handleApiError = async (error, dispatch, navigate) => {
    console.error('API Error:', error.response?.data || error.message);
    if (error.response && (error.response.data.status === 401 || error.response.data.status === 403)) {
        try {
            const response = await api.get('/user/logout', {
                withCredentials: true,
            });
            console.log('Logout response:', response);

            localStorage.removeItem('user');
            dispatch(logoutUserSuccess());
            navigate('/login');
        } catch (logoutError) {
            console.error('Logout error:', logoutError.response?.data || logoutError.message);
            localStorage.removeItem('user');
            dispatch(logoutUserSuccess());
            dispatch(apiError(logoutError.response?.data?.message || 'Logout error: Request failed'));
            navigate('/login');
        }
    } else {
        // Return error for non-401/403 cases to allow components/sagas to handle
        throw error;
    }
};

// Axios response interceptor
api.interceptors.response.use(
    (response) => response,
    (error) => {
        console.log('API Error:', error.response?.data);
        // Let handleApiError manage the error
        return Promise.reject(error);
    }
);

export default api;
